<template>
  <section v-if="specs.length" class="specs-section">
    <h2 class="technical-details-title">{{ $store.getters.t('technicalDetails') }}</h2>
    <div v-for="(group, index) in groupedSpecs" :key="group.name || index" class="spec-group" :class="{ 'is-open': openGroups[group.name] }">
      <button type="button" class="spec-group__heading" :class="{ 'is-open': openGroups[group.name] }" @click="toggle(group.name)">
        <span class="spec-group__name">{{ groupLabel(group.name) || $store.getters.t('specificationsTitle') }}</span>
        <span class="spec-toggle-button" aria-hidden="true">
          <span class="spec-toggle-icon"></span>
        </span>
      </button>
      <div v-show="openGroups[group.name]" class="spec-group__body">
        <div v-for="(spec, specIndex) in group.items" :key="spec.id || specIndex" class="spec-row">
          <span>{{ spec.specName }}</span>
          <strong>{{ spec.specValue }}</strong>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductSpecs',
  props: { specs: { type: Array, default: () => [] } },
  data () { return { openGroups: {} } },
  computed: {
    groupedSpecs () {
      const groups = this.specs.reduce((result, spec) => {
        const groupName = this.normalizeGroupName(spec.groupName || spec.group_name)
        if (!groupName) return result
        const group = result.find(item => item.name === groupName)
        if (group) group.items.push(spec)
        else result.push({ name: groupName, items: [spec] })
        return result
      }, [])
      const order = { BASIC: 0, ENGINE: 1, DIMENSIONS: 2 }
      return groups.sort((left, right) => {
        const leftOrder = order[left.name] === undefined ? 99 : order[left.name]
        const rightOrder = order[right.name] === undefined ? 99 : order[right.name]
        return leftOrder - rightOrder
      })
    }
  },
  watch: {
    groupedSpecs: {
      immediate: true,
      handler (groups) {
        const state = {}
        groups.forEach((group, index) => { state[group.name] = index === 0 })
        this.openGroups = state
      }
    }
  },
  methods: {
    normalizeGroupName (name) {
      const value = String(name || '').trim()
      return {
        '基础信息': 'BASIC',
        '尺寸': 'DIMENSIONS',
        '发动机': 'ENGINE'
      }[value] || value
    },
    groupLabel (name) {
      const key = {
        BASIC: 'specGroupBasic',
        DIMENSIONS: 'specGroupDimensions',
        ENGINE: 'specGroupEngine'
      }[this.normalizeGroupName(name)]
      return key ? this.$store.getters.t(key) : this.normalizeGroupName(name)
    },
    toggle (name) { this.$set(this.openGroups, name, !this.openGroups[name]) }
  }
}
</script>
